import React, { useState } from 'react';
import { X, Wallet, Loader } from 'lucide-react';
import { apiCall } from '../../services/apiUtil';
import toast from 'react-hot-toast';

const ChangePoolOwnerModal = ({ groupId, members, currentExpenseManagerId, onClose, onSaved, theme }) => {
  const [selectedMemberId, setSelectedMemberId] = useState(String(currentExpenseManagerId || ''));
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedMemberId) { toast.error('Select a member'); return; }
    setSaving(true);
    try {
      await apiCall(`/groups/${groupId}`, {
        method: 'PUT',
        body: JSON.stringify({ expenseManagerId: parseInt(selectedMemberId) }),
      });
      toast.success('Pool owner updated');
      window.location.reload();
    } catch (err) {
      toast.error(err.message || 'Failed to update pool owner');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className={`${theme.card} rounded-2xl border ${theme.border} w-full max-w-sm shadow-2xl`}>
        <div className={`flex items-center justify-between px-5 py-4 border-b ${theme.border}`}>
          <div className="flex items-center gap-2">
            <Wallet className="w-4 h-4 text-emerald-500" />
            <h2 className={`font-semibold ${theme.text}`}>Change Pool Owner</h2>
          </div>
          <button onClick={onClose} className={`p-1.5 rounded-lg ${theme.textSecondary} hover:text-red-400 transition-colors`}>
            <X className="w-4 h-4" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label className={`block text-xs font-semibold uppercase tracking-wide ${theme.textSecondary} mb-1.5`}>
              Select Member
            </label>
            <select
              value={selectedMemberId}
              onChange={e => setSelectedMemberId(e.target.value)}
              required
              className={`w-full px-3 py-2.5 rounded-xl border ${theme.border} ${theme.card} ${theme.text} text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500/40`}
            >
              <option value="">Select a member…</option>
              {(members || []).filter(m => m.status === 'active').map(m => (
                <option key={m.id} value={m.id}>
                  {m.firstName} {m.lastName}{m.role === 'admin' ? ' (Admin)' : ''}
                </option>
              ))}
            </select>
          </div>

          <div className="flex gap-3 pt-1">
            <button type="button" onClick={onClose} className={`flex-1 py-2.5 rounded-xl text-sm font-semibold ${theme.buttonSecondary}`}>
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="flex-1 py-2.5 rounded-xl text-sm font-semibold bg-emerald-500 text-white hover:bg-emerald-600 disabled:opacity-50 flex items-center justify-center gap-2 transition-colors"
            >
              {saving && <Loader className="w-4 h-4 animate-spin" />}
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePoolOwnerModal;
